import React, { useEffect, useState } from 'react';
import { SelectType } from './SelectType';
import { AddDetails } from './AddDetails';
export const CreateKreeda = ({ closing, setClosing, initialType, skipTypeSelection, }) => {
    const [currentStep, setCurrentStep] = useState(skipTypeSelection ? 1 : 0);
    const [kreeda, setKreeda] = useState({
        type: initialType || '',
        details: {
            name: '',
            duration: '',
        },
        settings: {},
    });
    const steps = [
        React.createElement(SelectType, { key: "select-type", currentStep: currentStep, setKreeda: setKreeda, setCurrentStep: setCurrentStep }),
        React.createElement(AddDetails, { key: "add-details", type: kreeda.type, setKreeda: setKreeda, setCurrentStep: setCurrentStep }),
        // 'Settings',
    ];
    /**
     * Advances to the next step in the wizard if available
     */
    // const handleNext = () => {
    //   if (currentStep < steps.length - 1) {
    //     setCurrentStep(currentStep + 1);
    //   }
    // };
    /**
     * Effect to reset the wizard state when closing
     */
    useEffect(() => {
        if (closing === true) {
            setCurrentStep(skipTypeSelection ? 1 : 0);
            setKreeda({
                type: initialType || '',
                details: {
                    name: '',
                    duration: '',
                },
                settings: {},
            });
            setClosing(false);
        }
    }, [closing, setClosing, skipTypeSelection, initialType]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "create-container" },
            React.createElement("div", { className: "create-content" }, steps.map((step, index) => (React.createElement("div", { key: index, className: "create-step", style: { transform: `translateX(-${currentStep * 100}%)` } }, step)))))));
};
